module.exports = __webpack_public_path__ + "static/media/pdf_icon.41f86048.svg";